import { PLAN_PREMIUM } from '../../../core/monetizacion/planes.js';

/**
 * Tipo de cuenta unificado para UI admin: free | userPremium | marketPremium.
 * Alineado a flags legacy (plan, negocio_premium, tipoCuenta).
 */
export function resolverTipoCuentaParaAdmin(u) {
  if (u?.tipoCuenta === 'marketPremium') return 'marketPremium';
  if (u?.tipoCuenta === 'userPremium') return 'userPremium';
  if (u?.negocioPremium === true) return 'marketPremium';
  if (String(u?.plan || '').toLowerCase() === PLAN_PREMIUM) return 'userPremium';
  return 'free';
}

/** Monto del abono manual (admin). Puede superar la deuda; el excedente va a saldo_favor_ars. */
export function parseMontoAbonoComisionAdmin(montoRaw) {
  const m = Number(String(montoRaw ?? '').replace(',', '.'));
  if (!Number.isFinite(m) || m <= 0) throw new Error('Ingresá un monto válido mayor a 0.');
  return Math.round(m * 100) / 100;
}

/** Prefijo para búsqueda por DNI (solo dígitos). */
export function normalizarPrefijoDniAdmin(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}

/**
 * Extrae id de producto desde URL/hash MLV o devuelve el string recortado si parece id.
 */
export function parseProductIdDesdeLinkPublicacion(raw) {
  const s = String(raw ?? '').trim();
  if (!s) return null;
  const hash = s.match(/#\/p\/([^/?#]+)/);
  if (hash) {
    try {
      return decodeURIComponent(hash[1]).trim() || null;
    } catch {
      return String(hash[1] || '').trim() || null;
    }
  }
  const path = s.match(/\/p\/([^/?#]+)/);
  if (path) {
    try {
      return decodeURIComponent(path[1]).trim() || null;
    } catch {
      return String(path[1] || '').trim() || null;
    }
  }
  const t = s.replace(/\s/g, '');
  if (/^[a-zA-Z0-9_-]{6,}$/.test(t)) return t;
  return null;
}

export function parseMontoAdminNoNegativo(raw) {
  const m = Number(String(raw ?? '').replace(',', '.'));
  if (!Number.isFinite(m) || m < 0) throw new Error('Ingresá un monto válido (≥ 0).');
  return Math.round(m * 100) / 100;
}

/** Días que la pauta del home permanece visible (1–365). Cada guardado reinicia el plazo desde ese momento. */
export function parseVigenciaDiasPublicidadHome(raw) {
  const n = parseInt(String(raw ?? '').trim(), 10);
  if (!Number.isFinite(n) || n < 1 || n > 365) {
    throw new Error('Indicá días de vigencia entre 1 y 365.');
  }
  return n;
}
